import CityPageTemplate from "../city-template/CityPageTemplate";
import { planoConfig } from "./data";

export default function PlanoPage() {
  return <CityPageTemplate config={planoConfig} />;
}